import { qrcodegen } from './qrcodegen'

export { qrcodegen }

export interface QrSvgOptions {
  /** Target SVG pixel size (width == height). Default 256. */
  size?: number
  /** Quiet-zone width in modules. Default 4 (QR spec minimum). */
  margin?: number
}

/**
 * [CANV-4] Encode `text` to an inline SVG QR at error-correction level M.
 * Black modules on a white background — deliberately NOT themed: a QR must stay black-on-white to
 * scan reliably in both light and dark app themes (spec D2 / QrCode component). The white
 * background is a genuine fixed-contrast literal (like a maplibre ramp), not chrome. Self-contained:
 * no network, no npm dep (encoder is the vendored qrcodegen.ts, MIT).
 */
export function buildQrSvg(text: string, opts: QrSvgOptions = {}): string {
  const margin = opts.margin ?? 4
  const px = opts.size ?? 256
  const qr = qrcodegen.QrCode.encodeText(text, qrcodegen.QrCode.Ecc.MEDIUM)
  const dim = qr.size + margin * 2

  // One <path> of all dark modules — compact and print-crisp.
  let path = ''
  for (let y = 0; y < qr.size; y++) {
    for (let x = 0; x < qr.size; x++) {
      if (qr.getModule(x, y)) {
        path += `M${x + margin},${y + margin}h1v1h-1z`
      }
    }
  }

  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="${px}" height="${px}" ` +
    `viewBox="0 0 ${dim} ${dim}" shape-rendering="crispEdges" role="img">` +
    `<rect width="${dim}" height="${dim}" fill="#ffffff"/>` +
    `<path d="${path}" fill="black"/>` +
    `</svg>`
  )
}
